import React from 'react'

let CancelBtn = () => {
    return (
        <div id="kr-cancel">
            <div onClick={() => { window.hideKreator() }}>
                <p>Anuluj</p>
                <div></div>
            </div>
        </div>
    )
}

export default CancelBtn
